function tierIndex(tiers, quantity) {
	return tiers.findIndex((tier) => {
		const start = parseInt(tier.starting_quantity, 10);
		const end =
			tier.ending_quantity == null || tier.ending_quantity === ""
				? Infinity
				: parseInt(tier.ending_quantity, 10);
		return Number.isFinite(start) && quantity >= start && quantity <= end;
	});
}

function tierRange(tier) {
	return tier.ending_quantity
		? `${tier.starting_quantity}–${tier.ending_quantity}`
		: `${tier.starting_quantity}+`;
}

export function paypalTierChangeMessage(tiers, currentQuantity, nextQuantity) {
	if (!Array.isArray(tiers) || tiers.length === 0) return "";
	if (Number(currentQuantity) === Number(nextQuantity)) return "";

	const currentTier = tierIndex(tiers, Number(currentQuantity));
	const nextTier = tierIndex(tiers, Number(nextQuantity));
	if (currentTier === -1 || nextTier === -1 || currentTier === nextTier) return "";

	return (
		`PayPal can't change this subscription from ${currentQuantity} to ${nextQuantity} hosts ` +
		`because that moves it from the ${tierRange(tiers[currentTier])} host tier to the ${tierRange(tiers[nextTier])} host tier. ` +
		"PayPal only allows host changes inside the same tier. Contact support to make this change."
	);
}
